/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceList_storeLists$ref = any;
export type MarkAsPaidInput = {|
  clientMutationId?: ?string,
  id: string,
  storeId: string,
|};
export type markAsPaidMutationVariables = {|
  input: MarkAsPaidInput,
  storeId: string,
|};
export type markAsPaidMutationResponse = {|
  +markAsPaid: ?{|
    +invoice: ?{|
      +id: string
    |},
    +storeLists: ?{|
      +$fragmentRefs: InvoiceList_storeLists$ref
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type markAsPaidMutation = {|
  variables: markAsPaidMutationVariables,
  response: markAsPaidMutationResponse,
|};
*/


/*
mutation markAsPaidMutation(
  $input: MarkAsPaidInput!
  $storeId: ID!
) {
  markAsPaid(input: $input) {
    invoice {
      id
    }
    storeLists {
      ...InvoiceList_storeLists_1dSt7N
      id
    }
    errors {
      key
      messages
    }
  }
}

fragment InvoiceList_storeLists_1dSt7N on StoreLists {
  id
  invoices(storeId: $storeId) {
    id
    startDate
    endDate
    amountDue
    state
    invoiceNumber
    invoicePdfUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MarkAsPaidInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Invoice",
  "kind": "LinkedField",
  "name": "invoice",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "storeId",
    "variableName": "storeId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markAsPaidMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkAsPaidPayload",
        "kind": "LinkedField",
        "name": "markAsPaid",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "InvoiceList_storeLists"
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markAsPaidMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkAsPaidPayload",
        "kind": "LinkedField",
        "name": "markAsPaid",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "Invoice",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountDue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoicePdfUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "markAsPaidMutation",
    "operationKind": "mutation",
    "text": "mutation markAsPaidMutation(\n  $input: MarkAsPaidInput!\n  $storeId: ID!\n) {\n  markAsPaid(input: $input) {\n    invoice {\n      id\n    }\n    storeLists {\n      ...InvoiceList_storeLists_1dSt7N\n      id\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment InvoiceList_storeLists_1dSt7N on StoreLists {\n  id\n  invoices(storeId: $storeId) {\n    id\n    startDate\n    endDate\n    amountDue\n    state\n    invoiceNumber\n    invoicePdfUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '137035ec7453b54505cb90b0b7f487a3';

module.exports = node;
